import { createMuiTheme, makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { CssBaseline } from '@material-ui/core';
import React from 'react';
import MensagemAlerta from './features/mensagemAlerta';
import Layout from './shared/layout/Layout';
import Routes from './Routes';
import styles from './theme';
import './App.css';
import { inicializarAnalytics } from "./shared/utils/GoogleAnalytics";

const temaProjeto = createMuiTheme(styles);

function App() {
  useStyles();

  inicializarAnalytics();

  return (
    <ThemeProvider theme={temaProjeto}>
      <CssBaseline />
      <Layout>
        <Routes />
        <MensagemAlerta />
      </Layout>
    </ThemeProvider>
  );
}

const useStyles = makeStyles(() => ({
  '@global': styles.global,
}));

export default App
